// frontend/src/components/ActionPlans/SubAreas.jsx

import React, { useState, useEffect } from 'react';
import { ap_subAreasAPI, ap_areasAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const APSubAreas = () => {
  const { t } = useTranslation();
  const [areaOptions, setAreaOptions] = useState([]);

  useEffect(() => {
    ap_areasAPI.getAll().then(r => {
      if (r.data?.success) {
        setAreaOptions(
          r.data.data
            .filter(a => a.is_active)
            .map(a => ({ value: a.area_id, label: a.area_name }))
        );
      }
    }).catch(err => console.error('Failed to load areas:', err));
  }, []);

  const columns = [
    {
      header: t('sub_areas.name', 'Name'),
      field: 'sub_area_name'
    },
    {
      header: t('areas.title', 'Area'),
      field: 'area_name'
    },
    {
      header: t('active', 'Active'),
      field: 'is_active',
      render: (row) => row.is_active ? '✓' : '—'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString()
    }
  ];

  const formFields = [
    {
      name: 'sub_area_name',
      label: 'sub_areas.name',
      type: 'text',
      required: true,
      maxLength: 100
    },
    {
      name: 'area_id',
      label: 'areas.title',
      type: 'select',
      required: true,
      options: areaOptions
    },
    {
      name: 'is_active',
      label: 'active',
      type: 'checkbox',
      defaultValue: true,
      checkboxLabel: 'active'
    }
  ];

  return (
    <MasterDataManager
      title="sub_areas.title"
      subtitle="sub_areas.subtitle"
      createButtonLabel="sub_areas.create"
      api={ap_subAreasAPI}
      columns={columns}
      formFields={formFields}
      idField="sub_area_id"
      displayField="sub_area_name"
    />
  );
};

export default APSubAreas;